import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Stack } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

interface Props {
  isSubmitting: boolean;
  disabled?: boolean;
}

const CommonActionButton: React.FC<Props> = ({ isSubmitting, disabled }) => {
  const navigate = useNavigate();
  return (
    <Grid container justifyContent="flex-end">
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          onClick={() => {
            navigate(-1);
          }}
        >
          戻る
        </Button>
        <LoadingButton disabled={disabled} variant="contained" type="submit" color="primary" loading={isSubmitting}>
          登録
        </LoadingButton>
      </Stack>
    </Grid>
  );
};

export default CommonActionButton;
